export const COOKIE_NAME = "app_session_id";
export const IMPERSONATION_COOKIE_NAME = "app_impersonation_backup";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

export const OAUTH_STATE_COOKIE = "__Host-oauth_state";

export type OAuthState = {
  redirectUri: string;
  returnPath: string;
  nonce: string;
};

export function encodeOAuthState(state: OAuthState): string {
  return btoa(JSON.stringify(state));
}

export function decodeOAuthState(state: string | undefined): OAuthState {
  if (!state) return { redirectUri: "", returnPath: "/", nonce: "" };

  try {
    const parsed = JSON.parse(atob(state)) as Partial<OAuthState>;
    return {
      redirectUri: typeof parsed.redirectUri === "string" ? parsed.redirectUri : "",
      returnPath: typeof parsed.returnPath === "string" && parsed.returnPath.startsWith("/") ? parsed.returnPath : "/",
      nonce: typeof parsed.nonce === "string" ? parsed.nonce : "",
    };
  } catch {
    return { redirectUri: "", returnPath: "/", nonce: "" };
  }
}
